import { createI18n } from 'vue-i18n'
import id from '@vue3/i18n/id.json'
import en from '@vue3/i18n/en.json'
import { getLocale } from '@/utils/common'

const i18n = createI18n({
  locale: getLocale(),
  messages: {
    EN: en,
    ID: id
  }
})
export default i18n
